import { TOOlTIP_FIELDS } from 'static/tooltipFields';

export const CONTACT_TYPE = [
  { value: 'Primary QA Contact', displayName: 'Primary QA Contact' },
  { value: 'QA Contact', displayName: 'QA Contact' },
  { value: 'Sales Contact', displayName: 'Sales Contact' },
  { value: 'Business Contact', displayName: 'Business Contact' },
  { value: '24 Hour Contact', displayName: '24 Hour Contact' },
  { value: 'Packaging Contact', displayName: 'Packaging Contact' },
  { value: 'Plant Manager', displayName: 'Plant Manager' },  
  { value: 'Customer Care Contact', displayName: 'Customer Care Contact' },
];

export const DEFAULT_STATE = { visible: false, mode: 'add', data: {} };

export const CONTACT_COLUMNS_AG = [
  {
    dataType: 'string',
    headerName: 'Type',
    fieldName: 'Type',
    fieldNameCamelCase: 'type',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'Associated Retailers',
    fieldName: 'associatedretailers',
    fieldNameCamelCase: 'associatedRetailers',
    allowFilter: false,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'First Name',
    fieldName: 'FirstName',
    fieldNameCamelCase: 'firstName',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'Last Name',
    fieldName: 'LastName',
    fieldNameCamelCase: 'lastName',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'Department',
    fieldName: 'Department',
    fieldNameCamelCase: 'department',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'Phone Number',
    fieldName: 'PhoneNumber',
    fieldNameCamelCase: 'phoneNumber',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'MainAddress',
    fieldName: 'Address',
    fieldNameCamelCase: 'address',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'Email',
    fieldName: 'Email',
    fieldNameCamelCase: 'email',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'City',
    fieldName: 'City',
    fieldNameCamelCase: 'city',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
  {
    dataType: 'string',
    headerName: 'State',
    fieldName: 'State',
    fieldNameCamelCase: 'state',
    allowFilter: true,
    allowSort: true,
    resizable: true,
  },
];

export const CONTACT_COLUMNS = [
  {
    title: 'Type',
    fieldName: 'type',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.contactType.fieldPath,
  },
  {
    title: 'Associated Retailers',
    fieldName: 'associatedRetailers',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.contactAssociatedRetailers.fieldPath,
  },
  {
    title: 'First Name',
    fieldName: 'firstName',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.contactFirstName.fieldPath,
  },
  {
    title: 'Last Name',
    fieldName: 'lastName',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.contactLastName.fieldPath,
  },
  {
    title: 'Department',
    fieldName: 'department',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.contactDepartment.fieldPath,
  },
  {
    title: 'Phone Number',
    fieldName: 'phoneNumber',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.contactPhoneNumber.fieldPath,
  },
  {
    title: 'Email',
    fieldName: 'email',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.contactEmail.fieldPath,
  },
  {
    title: 'Main Address',
    fieldName: 'address',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.contactAddress.fieldPath,
  },
  {
    title: 'City',
    fieldName: 'city',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.contactCity.fieldPath,
  },
  {
    title: 'State',
    fieldName: 'state',
    minWidth: 100,
    fieldPath: TOOlTIP_FIELDS.contactState.fieldPath,
  },
];
